module.exports = __webpack_public_path__ + "static/media/SDFSA_6-682w.54f21257.jpg";